import { useEffect } from 'react';

import { useFlag } from '../../services/launchDarkly';
import type { LDFlags } from '../../services/types';
import { useStores } from '../useStores';

const PLAYING_NOW_FLAG = 'playing_now_badge_feature' satisfies LDFlags;

/** Polls while the lobby is mounted and `playing_now_badge_feature` is 'on'; resets the store when it is not. */
export function usePlayingNowPolling(): void {
  const { playingNowStore } = useStores();
  const enabled = useFlag<string>(PLAYING_NOW_FLAG, 'off') === 'on';

  useEffect(() => {
    if (!enabled) {
      // Also drops counts kept from a previous visit if the flag went off meanwhile.
      playingNowStore.reset();

      return undefined;
    }

    playingNowStore.activate();

    return () => playingNowStore.deactivate();
  }, [enabled, playingNowStore]);
}
